module.exports = __webpack_public_path__ + "img/7.9b80f332.png";